import { useNavigate } from "react-router-dom";
import { Home, ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";

/**
 * 404 Not Found Page for Partner Portal
 *
 * Branded error page displayed when users navigate to non-existent routes.
 */
export function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#282828] via-[#4c1d95] to-[#282828]">
      <div className="max-w-md w-full mx-4 bg-[#282828]/80 backdrop-blur-sm border border-[#1283EB]/30 rounded-2xl p-8 shadow-2xl">
        {/* Logo */}
        <div className="flex justify-center mb-6">
          <img
            src="/aiia-logo-white.svg"
            alt="AIIA Logo"
            className="h-16"
          />
        </div>

        {/* 404 Display */}
        <div className="flex justify-center mb-4">
          <div className="bg-[#1283EB]/20 rounded-2xl px-6 py-3 border border-[#1283EB]/30">
            <span className="text-5xl font-bold text-white">404</span>
          </div>
        </div>

        {/* Title */}
        <h1 className="text-2xl font-bold text-[#F8F3EC] text-center mb-2">
          Page not found
        </h1>

        {/* Description */}
        <p className="text-white/60 text-center mb-8">
          The page you're looking for doesn't exist or has been moved. Check the
          URL or navigate back to the dashboard.
        </p>

        {/* Action Buttons */}
        <div className="space-y-3">
          <Button
            onClick={() => navigate("/")}
            className="w-full h-13 bg-[#1283EB] hover:bg-[#1283EB]/90 text-white font-medium rounded-lg transition-all focus:outline-none focus:ring-2 focus:ring-[#1283EB] focus:ring-offset-2 focus:ring-offset-[#282828]"
          >
            <Home className="h-5 w-5 mr-2" aria-hidden="true" />
            Go to Dashboard
          </Button>

          <Button
            onClick={() => navigate(-1)}
            variant="outline"
            className="w-full h-12 bg-transparent hover:bg-white/10 text-white border-white/20 rounded-lg transition-colors"
          >
            <ArrowLeft className="h-4 w-4 mr-2" aria-hidden="true" />
            Go Back
          </Button>
        </div>

        {/* Help Text */}
        <div className="mt-8 text-center">
          <p className="text-sm text-white/50">
            Looking for something specific?{" "}
            <a
              href="mailto:support@aiia.io"
              className="text-[#1283EB] hover:text-[#1283EB]/80 underline"
            >
              Contact support
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}

export default NotFound;
